import axios from 'axios';

const editIssueDetails = (values) =>
{
    const payload = { ...values };
    delete payload.comments;
    delete payload.images;
    delete payload.farmerID;
    delete payload.created_at;
    delete payload.updated_at;

    console.log("In axios");

    console.log(payload);

    return axios
        .post(`${process.env.REACT_APP_API_URL}/api/issue/editIssue`, payload)
        .then((res) =>
        {   
            return res;
        })
        .catch((err) =>
        {
            return err;
        });
}
export default editIssueDetails;